/**
 * Integración Service Worker ↔ cola offline de pedidos + reparación PWA.
 */

const SYNC_TAG = 'poskn-queue-sync';

function isDesktopShell(win) {
	return !!(win.POSKN_IS_DESKTOP || (win.posknDesktop && win.posknDesktop.isDesktop));
}

export function initSwSync(win) {
	if (win._posknSwSyncBound) return;
	win._posknSwSyncBound = true;

	win.posknRegisterQueueBackgroundSync = function posknRegisterQueueBackgroundSync() {
		if (isDesktopShell(win)) return Promise.resolve(false);
		if (!('serviceWorker' in win.navigator)) return Promise.resolve(false);
		return win.navigator.serviceWorker.ready
			.then((reg) => {
				if (!reg.sync || typeof reg.sync.register !== 'function') return false;
				return reg.sync.register(SYNC_TAG).then(() => true);
			})
			.catch(() => false);
	};

	win.posknNotifySwQueuePending = function posknNotifySwQueuePending() {
		if (isDesktopShell(win)) return;
		if (!('serviceWorker' in win.navigator) || !win.navigator.serviceWorker.controller) return;
		try {
			win.navigator.serviceWorker.controller.postMessage({
				type: 'POSKN_QUEUE_PENDING',
			});
		} catch (e) {
			/* ignore */
		}
	};

	/**
	 * Limpia caches del Service Worker y recarga (recupera PWA “rota” sin borrar todo el historial).
	 * En Desktop: pide al shell limpiar caché de la app.
	 */
	win.posknRepararAppPwa = async function posknRepararAppPwa() {
		if (isDesktopShell(win) && win.posknDesktop && typeof win.posknDesktop.clearAppCache === 'function') {
			const ok = win.confirm(
				'¿Limpiar caché de POSKN Desktop y reiniciar?\n\nNo borra la cola offline ni la URL guardada.',
			);
			if (!ok) return false;
			await win.posknDesktop.clearAppCache();
			win.location.reload();
			return true;
		}

		const ok = win.confirm(
			'¿Reparar la app POS?\n\nSe limpiará la caché del PWA y se recargará. No borra pedidos en cola ni el historial completo del navegador.',
		);
		if (!ok) return false;

		try {
			if ('caches' in win) {
				const keys = await win.caches.keys();
				await Promise.all(
					keys.filter((k) => k.indexOf('poskn') !== -1).map((k) => win.caches.delete(k)),
				);
			}
		} catch (e) {
			/* ignore */
		}

		try {
			if ('serviceWorker' in win.navigator) {
				const regs = await win.navigator.serviceWorker.getRegistrations();
				for (const reg of regs) {
					if (reg.active) {
						reg.active.postMessage({ type: 'CLEAR_CACHES' });
					}
					if (reg.waiting) {
						reg.waiting.postMessage({ type: 'SKIP_WAITING' });
					}
					await reg.update();
				}
			}
		} catch (e2) {
			/* ignore */
		}

		if (typeof win.mostrarNotificacion === 'function') {
			win.mostrarNotificacion('Reparando app… recargando', 'info');
		}
		win.setTimeout(() => {
			win.location.reload();
		}, 400);
		return true;
	};

	// Desktop: sync de cola solo por evento online (sin SW)
	if (isDesktopShell(win)) {
		win.addEventListener('online', () => {
			const pending =
				typeof win.getColaPendientesSubir === 'function' ? win.getColaPendientesSubir().length : 0;
			if (pending > 0 && typeof win.procesarColaSubida === 'function') {
				win.procesarColaSubida();
			}
		});
		return;
	}

	if ('serviceWorker' in win.navigator) {
		win.navigator.serviceWorker.addEventListener('message', (event) => {
			const data = event.data || {};
			if (data.type === 'POSKN_PROCESS_QUEUE') {
				if (typeof win.procesarColaSubida === 'function') {
					win.procesarColaSubida();
				}
			}
		});

		let refreshing = false;
		win.navigator.serviceWorker.addEventListener('controllerchange', () => {
			if (refreshing) return;
			refreshing = true;
			win.location.reload();
		});
	}

	win.addEventListener('online', () => {
		const pending =
			typeof win.getColaPendientesSubir === 'function' ? win.getColaPendientesSubir().length : 0;
		if (pending > 0) {
			win.posknRegisterQueueBackgroundSync();
			if (typeof win.procesarColaSubida === 'function') {
				win.procesarColaSubida();
			}
		}
	});
}
